import { render, staticRenderFns } from "./FieldChoiceModal.vue?vue&type=template&id=0803fdea&"
import script from "./FieldChoiceModal.vue?vue&type=script&lang=ts&"
export * from "./FieldChoiceModal.vue?vue&type=script&lang=ts&"
import style0 from "./FieldChoiceModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports